module.exports = __webpack_public_path__ + "media/images/prizes__second-906ecb61a37a48373bee43449463bf09.jpg";